import ResourceService from './resource.service'

class AccountService extends ResourceService {
  static get resource() {
    return 'finance-account'
  }
}

export default AccountService
